document.addEventListener('DOMContentLoaded', () => {

    // Thumbnails slider
    const thumbSwiper = new Swiper('.thumb-swiper', {
      slidesPerView: 'auto',
      direction: 'vertical', 
      spaceBetween: 4, 
      wrapperClass: 'thumb-wrapper',
      slideClass: 'thumb-media',
      freeMode: true,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
    });

    // Main image slider with thumbs control
    const mainSwiper = new Swiper('.main-swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      wrapperClass: 'main-wrapper',
      slideClass: 'main-media',
      pagination: {
        el: '.swiper-pagination-main',
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });
  // ────────────────────────────────────────────────
  // Pure JS lightbox (replaces Magnific Popup)
  // Works on both mobile & desktop
  // ────────────────────────────────────────────────
  const triggers = document.querySelectorAll('.image-popup-vertical-fit');
  if (triggers.length === 0) return;
  // Create lightbox container once
  const lightbox = document.createElement('div');
  lightbox.className = 'lightbox';
  lightbox.innerHTML = `
    <span class="close-btn">&times;</span>
    <span class="prev">&lsaquo;</span>
    <span class="next">&rsaquo;</span>
    <div class="counter">1 / 1</div>
  `;
  document.body.appendChild(lightbox);
  const imgWrapper = document.createElement('div');
  const img = document.createElement('img');
  imgWrapper.appendChild(img);
  lightbox.insertBefore(imgWrapper, lightbox.querySelector('.close-btn'));
  let currentIndex = 0;
  const images = [];
  // Collect all large image URLs
  triggers.forEach((trigger, index) => {
    const largeSrc = trigger.getAttribute('href') || trigger.querySelector('img')?.src;
    if (!largeSrc) return;
    images.push(largeSrc);
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      currentIndex = index;
      openLightbox();
    });
  });
  function openLightbox() {
    if (images.length === 0) return;
    updateImage();
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Double-click = zoom toggle
    img.addEventListener('dblclick', toggleZoom, { once: true });
  }
  function updateImage() {
    img.src = images[currentIndex];
    img.alt = `Product image ${currentIndex + 1} of ${images.length}`;
    document.querySelector('.counter').textContent = `${currentIndex + 1} / ${images.length}`;

    // Reset zoom state
    lightbox.classList.remove('zoom-in');
    img.style.transform = 'scale(1)';
  }
  function toggleZoom() {
    lightbox.classList.toggle('zoom-in');
  }
  function nextImage() {
    currentIndex = (currentIndex + 1) % images.length;
    updateImage();
  }
  function prevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateImage();
  }
  // ────────────────────────────────────────────────
  // Event listeners for lightbox
  // ────────────────────────────────────────────────
  lightbox.querySelector('.close-btn').addEventListener('click', closeLightbox);
  lightbox.querySelector('.next').addEventListener('click', nextImage);
  lightbox.querySelector('.prev').addEventListener('click', prevImage);
  // Click outside image → close
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox || e.target === imgWrapper) {
      closeLightbox();
    }
  });
  // Keyboard support
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('active')) return;
    switch (e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowRight':
        nextImage();
        break;
      case 'ArrowLeft':
        prevImage();
        break;
    }
  });
  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
    img.src = ''; // clear to save memory
    lightbox.classList.remove('zoom-in');
  }
});

document.addEventListener('change', function(e) {
  if (e.target.classList.contains('productOption')) {
    const selectedImage = e.target.getAttribute('data-image');
    if (!selectedImage) return;
    const firstMainSlide = document.querySelector('.main-wrapper .main-media');
    if (firstMainSlide) {
      const mainImg = firstMainSlide.querySelector('img');
      const mainLink = firstMainSlide.querySelector('a');
      if (mainImg) mainImg.src = selectedImage;
      if (mainLink) mainLink.href = selectedImage;
    }
    const firstThumb = document.querySelector('.thumb-wrapper .thumb-media img');
    if (firstThumb) {
      firstThumb.src = selectedImage;
    }
    const swiperInstance = document.querySelector('.main-swiper').swiper;
    if (swiperInstance) {
      swiperInstance.slideTo(0);
    }
    console.log('Gallery Updated To:', selectedImage);
  }
});

document.addEventListener('change', function(e) {

  if (!e.target.classList.contains('productOption')) return;

  // Get selected options
  const selectedOptions = [];
  document.querySelectorAll('.productOption:checked').forEach(input => {
    selectedOptions.push(input.value);
  });

  // Get ALL variants
  const variantsData = document.getElementById('ProductVariantsJson');
  if (!variantsData) return;

  const variants = JSON.parse(variantsData.textContent);

  // Find correct variant
  const matchedVariant = variants.find(variant => {
    return variant.options.every((option, index) => {
      return option === selectedOptions[index];
    });
  });

  if (!matchedVariant) return;

  console.log("Matched Variant:", matchedVariant);

  // If variant has image
  if (matchedVariant.featured_image) {

    const newImage = matchedVariant.featured_image.src;

    const mainImg = document.querySelector('.main-wrapper .main-media img');
    const mainLink = document.querySelector('.main-wrapper .main-media a');

    if (mainImg) mainImg.src = newImage;
    if (mainLink) mainLink.href = newImage;

    const firstThumb = document.querySelector('.thumb-wrapper .thumb-media img');
    if (firstThumb) firstThumb.src = newImage;

    const swiperInstance = document.querySelector('.main-swiper')?.swiper;
    if (swiperInstance) swiperInstance.slideTo(0);
  }

});